import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { CacheService } from '@insite-store360/services';
import { of, tap } from 'rxjs';

export const cacheInterceptor: HttpInterceptorFn = (req, next) => {
    const cacheService = inject(CacheService);
    const cache = cacheService.cache;

    // Clear cache for POST/PUT/PATCH/DELETE requests
    if (req.method !== 'GET') {
        // Extract API base path (e.g., /api/product-service)
        const currentApiPath = req.url.split('/').slice(0, 5).join('/');

        cache.forEach((value, key) => {
            const cachedApiPath = key.split('/').slice(0, 5).join('/');
            console.log('cachedApiPath', cachedApiPath);
            console.log('currentApiPath', currentApiPath);
            if (cachedApiPath === currentApiPath) {
                cache.delete(key);
            }
        });
        return next(req);
    }

    const cachedResponse = cache.get(req.urlWithParams);
    if (cachedResponse) {
        return of(cachedResponse);
    }

    return next(req).pipe(
        tap(event => {
            if (event instanceof HttpResponse) {
                cache.set(req.urlWithParams, event);
            }
        })
    );
};
